import { RefObject, useEffect, useRef } from 'react';
import { useModal } from '../common/modal';

export function useCloseOnOutsideClick(
  closePopup: () => void,
  ignoredRefs: RefObject<HTMLElement>[] = []
) {
  const popupRef = useRef<HTMLDivElement>(null);
  const { isAnyModalOpened } = useModal();

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const isIgnoredTarget = ignoredRefs.some(
        (ref) => ref.current && ref.current.contains(event.target as Node)
      );

      if (isIgnoredTarget) return;

      if (
        !isAnyModalOpened() &&
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        closePopup();
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { popupRef };
}
